/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useCountdown } from "./hooks/useCountDown";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { PictureNewUserWelfare } from "./atom";

export function NewUserWelfare() {
  const { userInfo } = useGlobalStore();
  const { userProperty } = useUserPropertyStore();
  const { days, hours, minutes, seconds } = useCountdown(
    userInfo?.registerDate,
    userProperty?.picRechargeOver
  );

  return (
    <PictureNewUserWelfare>
      <div className="title">新用户充值</div>
      <div className="welfare-content">
        <span className="sub-title">限时福利</span>
        <span>单笔满100元 额外赠送 25元通用券</span>
        <span className="line">|</span>
        <span className="sub-title">福利仅剩</span>
        <span>{days}天</span>
        <div className="count-down">
          <div>{hours}</div>:<div>{minutes}</div>:<div>{seconds}</div>
        </div>
      </div>
    </PictureNewUserWelfare>
  );
}
